import React, { Component } from 'react';
import './index.less';
import HotNews from './HotNews';
import AdvertisementBanner from './AdvertisementBanner';
import MarketStatistics from './MarketStatistics';

export interface IABSHomeMiddleProps {
  getScrollParent?: any;
}

class ABSHomeMiddle extends Component<IABSHomeMiddleProps> {
  render() {
    const { getScrollParent } = this.props;
    return (
      <div className="abs-home-middle-content">
        <AdvertisementBanner />
        <MarketStatistics />
        <HotNews getScrollParent={getScrollParent} /> 
      </div>
    );
  }
}

export default ABSHomeMiddle; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/middle/index.tsx